export default __webpack_public_path__ + "static/media/dp.be2959bf.jpg";